export type Tuple<T, N extends number> = N extends N ? (number extends N ? T[] : _TupleOf<T, N, []>) : never;
type _TupleOf<T, N extends number, R extends unknown[]> = R['length'] extends N ? R : _TupleOf<T, N, [T, ...R]>;

export function assertTuple<T, Length extends number>(array: T[], length: Length): Tuple<T, Length> {
  const isExpectedLength = array.length === length;
  if (!isExpectedLength) {
    throw new Error(`Array of length ${length} expected, but received ${array.length}`);
  }
  return array as Tuple<T, Length>;
}
